import {
  projectDocumentProcessingRunToPrefill,
  type DocumentProcessingRun,
} from "./documentProcessingRun";

export type DocumentProcessingCompletionSummary = {
  medicationCount: number;
  appointmentCount: number;
  resultCount: number;
};

export function summarizeDocumentProcessingRuns(
  runs: readonly DocumentProcessingRun[],
): DocumentProcessingCompletionSummary {
  return runs.reduce(
    (summary, run) => {
      const projected = projectDocumentProcessingRunToPrefill(run, "");
      return {
        medicationCount:
          summary.medicationCount + (projected.medications?.length ?? 0),
        appointmentCount:
          summary.appointmentCount + (projected.appointments?.length ?? 0),
        resultCount: summary.resultCount + (projected.results?.length ?? 0),
      };
    },
    { medicationCount: 0, appointmentCount: 0, resultCount: 0 },
  );
}
